import CalendarResource from './calendar'
import BaseResource from './index'

export default class AvailabilityResource extends BaseResource {
    static endpoint = '/avail'

    static related() {
        return {
            calendar: CalendarResource
        }
    }

    static async quote(date, location = null) {
        const result = await this.wrap('/quote').get({ params: { date, location }})
        return result.data
    }
}
